import { configureStore } from "@reduxjs/toolkit";
import configReducer from "./configSlice";
import countryReducer from "./countrySlice";

export const store = configureStore({
  reducer: {
    configs: configReducer,
    country: countryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: true }),
});
